import React from "react";

export const SingleRow = ({ props }: any) => {
  const {
    user_id,
    user_name,
    user_email,
    user_phone,
    purchase_date,
    purchase_time,
    plan_end_date,
    plan_name,
    pro_module_name,
  } = props;
  return (
    <tr>
      <td>{user_id}</td>
      <td>{user_name}</td>
      <td>{user_email}</td>
      <td>{user_phone}</td>
      <td>
        {purchase_date
          .split("/")
          .map((part: any, index: any, arr: any) =>
            index === 0 ? arr[1] : index === 1 ? arr[0] : part
          )
          .join("/")}
      </td>
      <td>
        {plan_end_date
          .split("/")
          .map((part: any, index: any, arr: any) =>
            index === 0 ? arr[1] : index === 1 ? arr[0] : part
          )
          .join("/")}
      </td>
      <td>{plan_name}</td>
      <td> {pro_module_name} </td>
    </tr>
  );
};
